import { render, staticRenderFns } from "./AccountActivation.vue?vue&type=template&id=5d0b6e24&scoped=true&"
import script from "./AccountActivation.vue?vue&type=script&lang=js&"
export * from "./AccountActivation.vue?vue&type=script&lang=js&"
import style0 from "./AccountActivation.vue?vue&type=style&index=0&id=5d0b6e24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0b6e24",
  null
  
)

export default component.exports